export const FLAG_GETTING_PERSONS = 'FLAG_GETTING_PERSONS';
export const GET_PERSONS = 'GET_PERSONS';
export const CLEAR_PERSONS = 'CLEAR_PERSONS';

export const SET_PERSON_INPUT_FOCUS = 'SET_PERSON_INPUT_FOCUS';
export const CLEAR_PERSON_INPUT_FOCUS = 'CLEAR_PERSON_INPUT_FOCUS';

export const SET_PASSENGER_LIST = 'SET_PASSENGER_LIST';
export const CLEAR_PASSENGER_LIST = 'CLEAR_PASSENGER_LIST';


export const SET_FOCUS_CUSTOMER = 'SET_FOCUS_CUSTOMER';
export const CLEAR_FOCUS_CUSTOMER = 'CLEAR_FOCUS_CUSTOMER';